import {accessToken} from "../components/core/auth-service/auth-service";
import {
  GET_ORDER_TYPES_START,
  GET_ORDER_TYPES_SUCCESS,
  GET_ORDER_TYPES_FAILURE,
  RESET_ON_IMPERSONATION
} from "./actionTypes";
import {ErrorResponseWrapper} from "../model/ErrorResponseWrapper";
import getConfig from '../environment';

export const getOrderTypesBegin = () => ({
  type: GET_ORDER_TYPES_START,
  payload: {}
});

export const getOrderTypesSuccess = (payload: any) => ({
  type: GET_ORDER_TYPES_SUCCESS,
  payload: payload
});

export const getOrderTypesFailure = (errors: any) => ({
  type: GET_ORDER_TYPES_FAILURE,
  payload: {errors}
});

export const resetOrderTypesOnImpersonation = () => ({
  type: RESET_ON_IMPERSONATION,
});

const ORDER_TYPES_API = getConfig()?.orderTypesApi;

export async function getOrderTypesFromApi(dispatch:any, salesAreaDependentCustomerUid:string) {
  const getOrderTypesUrl = `${ORDER_TYPES_API}/${salesAreaDependentCustomerUid}`;
  dispatch(getOrderTypesBegin());
  return fetch(getOrderTypesUrl, {
    headers: {
      'Authorization': `Bearer ${await accessToken()}`,
      'Accept': 'application/json'
    }
  })
  .then(response => {
    console.log('order types response status = ', response.status);
      if(!response.ok) {
        throw new ErrorResponseWrapper(response)
      } else {
        return response.json()
      }
  })
  .then(data => {
    const orderScenarios = data.orderScenarios || [];
    dispatch(getOrderTypesSuccess(orderScenarios))
  })
  .catch((errorResponse) => {
    console.log('the error = ', errorResponse);
    if(errorResponse instanceof ErrorResponseWrapper) {
      dispatch(getOrderTypesFailure(errorResponse.getErrorMessages()))
    } else {
      const errorsObject = [errorResponse.message];
      dispatch(getOrderTypesFailure(errorsObject));
    }
  })
}

